import { z } from 'zod'
import { Temporal } from '@js-temporal/polyfill'
import type { Contract } from '../../models/Company'

export const ContractDTO = z.object({
  id: z.number(),
  schema: z.string().nullish(),
  created_at: z.string()
})

export type ContractDTO = z.infer<typeof ContractDTO>

export function mapContractToDTO (model: Contract): ContractDTO {
  return {
    id: model.id,
    created_at: model.createdAt.toString()
  }
}

export function mapDTOToContract (dto: ContractDTO): Contract {
  return {
    id: dto.id,
    schema: dto.schema ?? undefined,
    createdAt: Temporal.Instant.from(dto.created_at)
  }
}
